var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpBlack = function SvgArrowUpBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "arrow-up-black_svg__a",
    width: 18,
    height: 18,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h18v18H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrow-up-black_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0D0D0D",
    d: "M8.25 13.5V6.6l-2.7 2.7L4.5 8.25 9 3.75l4.5 4.5-1.05 1.05-2.7-2.7v6.9z"
  }))));
};
export { SvgArrowUpBlack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4IiBmaWxsPSJub25lIj4NCiAgPG1hc2sgaWQ9Im1hc2swXzQ3MF80MTAiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+DQogICAgPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiBmaWxsPSIjRDlEOUQ5Ii8+DQogIDwvbWFzaz4NCiAgPGcgbWFzaz0idXJsKCNtYXNrMF80NzBfNDEwKSI+DQogICAgPHBhdGggZD0iTTguMjUgMTMuNVY2LjZMNS41NSA5LjNMNC41IDguMjVMOSAzLjc1TDEzLjUgOC4yNUwxMi40NSA5LjNMOS43NSA2LjZWMTMuNUg4LjI1WiIgZmlsbD0iIzBEMEQwRCIvPg0KICA8L2c+DQo8L3N2Zz4=";